<script setup lang="ts" generic="T extends { id: string; name: string }">
import { computed } from 'vue'
import Select from 'primevue/select'

const props = defineProps<{
    options: T[]
    activeId?: string | null
}>()

const emit = defineEmits<{
    (e: 'change', instance: T): void
}>()

const activeValue = computed({
    get: () => props.activeId,
    set: v => {
        if (!v) return
        const inst = props.options.find(i => i.id === v)
        if (inst) emit('change', inst)
    }
})

const visible = computed(() => props.options.length > 1)
</script>

<template>
    <Select
        v-if="visible"
        v-model="activeValue"
        :options="options"
        option-label="name"
        option-value="id"
        placeholder="Vyberte instanci"
        :filter="options.length > 5"
        class="min-w-[140px] sm:min-w-[200px]"
    />
    <span v-else-if="options.length === 1" class="text-sm text-gray-700 font-medium">
        {{ options[0].name }}
    </span>
</template>
